var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_15121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9007 8.08122C31.6691 7.61797 31.1052 7.4321 30.6428 7.66191L26.8929 9.53691C26.4296 9.76853 26.2419 10.3316 26.4736 10.7948C26.7049 11.2562 27.2651 11.4458 27.7315 11.2142L31.4814 9.33916C31.9447 9.10753 32.1324 8.54447 31.9007 8.08122Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4814 18.9115L27.7315 17.0365C27.2682 16.8058 26.7061 16.9916 26.4736 17.4558C26.2419 17.919 26.4296 18.4821 26.8929 18.7137L30.6428 20.5887C31.1106 20.821 31.6702 20.6293 31.9007 20.1694C32.1324 19.7062 31.9447 19.1431 31.4814 18.9115Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5623 15.1248H7.49994V10.3124C7.49994 7.72781 9.60287 5.62494 12.1874 5.62494C14.7719 5.62494 16.8748 7.72787 16.8748 10.3124V12.1874C16.8748 12.7056 17.2941 13.1249 17.8123 13.1249H21.5623C22.0804 13.1249 22.4998 12.7056 22.4998 12.1874V10.3124C22.4998 4.62612 17.8736 0 12.1874 0C6.50112 0 1.875 4.62612 1.875 10.3124V15.2975C0.786125 15.6858 0 16.7167 0 17.9373V29.1871C0 30.738 1.26163 31.9996 2.81244 31.9996H21.5623C23.1131 31.9996 24.3747 30.7379 24.3747 29.1871V17.9373C24.3747 16.3864 23.1131 15.1248 21.5623 15.1248ZM13.1249 24.327V27.3121C13.1249 27.8303 12.7056 28.2496 12.1874 28.2496C11.6692 28.2496 11.2499 27.8303 11.2499 27.3121V24.327C10.161 23.9387 9.37488 22.9078 9.37488 21.6873C9.37488 20.1364 10.6365 18.8748 12.1874 18.8748C13.7382 18.8748 14.9998 20.1364 14.9998 21.6873C14.9998 22.9079 14.2137 23.9387 13.1249 24.327Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0621 13.1875H27.3122C26.794 13.1875 26.3747 13.6068 26.3747 14.125C26.3747 14.6432 26.794 15.0625 27.3122 15.0625H31.0621C31.5803 15.0625 31.9996 14.6432 31.9996 14.125C31.9996 13.6068 31.5803 13.1875 31.0621 13.1875Z",
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_15121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.ceba5f43311b5a2e5b98958e3697a8c2.svg";
export { ForwardRef as ReactComponent };